import './App.css';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSwipeable } from 'react-swipeable';




function Preview ({onClick, display, image}) {

  const isMobile = useMediaQuery({ query: `(max-width: 1132px)` });

  return (
    <div className='preview' style={{display: display}}>
      <div className='close-wrapper'><button onClick={onClick} className='close'><p className='text secondary' style={{fontSize: '14px', whiteSpace: 'nowrap', color: 'rgb(181, 181, 170)'}}>Close preview</p></button></div>
       <div className='frame' style={{aspectRatio: '1456 / 916', maxWidth: '95%', maxHeight: '95%', width: 'auto', borderRadius: '2px'}}><img style={{width: '100%', height: 'auto', aspectRatio: '1440 / 900'}} src={image} alt="Image"></img></div>
    </div>
  );
}


export default Preview